import FooterButtonContainer from './FooterButtonContainer';

const Footer = ({
  leftButtons = [],
  rightButtons = []
}) => {
  return (
    <div className="footer">
      <FooterButtonContainer
        buttons={leftButtons}
        className="left-box"
      />

      <FooterButtonContainer
        buttons={rightButtons}
        className="right-box"
      />
    </div>
  );
};

export default Footer;
